import { useFormikContext } from 'formik';
import React from 'react'
import { toast } from 'react-toastify';
import { IconBack } from 'src/app/modules/component/IconSvg';
import InfoPatientRight from 'src/app/modules/phan-he-kham-benh/components/InfoPatientRight';
import { ServiceTemplateButton } from 'src/app/modules/phan-he-kham-benh/components/service-template-button';
import { handleConvertBenhNhanInfo } from 'src/app/modules/phan-he-noi-tru/common/functionCommon';
import { ORDER_TYPE_ID } from 'src/app/modules/utils/Constant';
import { usePhanHeDieuTriNoiTruContext } from '../../../PhanHeDieuTriContext';
import { parseJSON } from 'src/app/modules/utils/FormatUtils'

type Props = {
    onClose?: () => void;
    tableData: any[];
    setTableData: (data: any[]) => void;
    khoMauSelected: any;
    setKhoMauSelected: (data: any) => void;
}

const HeaderMau = (props: Props) => {
    const { onClose, tableData, setTableData, khoMauSelected, setKhoMauSelected } = props;
    const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
    const { values } = useFormikContext<any>();


    const getDonMauParams = () => {
        const formValue = JSON.stringify({
            ...values,
            khoMauSelected
        });
        const tableValue = tableData.map((row) => ({
            orderType: parseInt(ORDER_TYPE_ID.MAU),
            orderTemplate: JSON.stringify({
                ...row,
                inventoryItemId: null
            }),
        }));

        return {
            orderType: parseInt(ORDER_TYPE_ID.MAU),
            orderTemplate: formValue,
            lstOrderSetMemebers: tableValue,
        };
    };

    const onSelectMauChiDinhMau = (data: any) => {
        const tableValue = data.lstOrderSetMemebers.map((row: any) => ({
            ...JSON.parse(row.orderTemplate),
        }));
        const orderTemplateData = parseJSON(data.orderTemplate);
        setKhoMauSelected(orderTemplateData?.khoMauSelected);
        setTableData(tableValue);
    };

    const saveDonMauValidation = () => {
        if (!tableData.length) {
            toast.warn('Chưa có máu được chỉ định cho mẫu này');
            return false;
        }

        return true;
    };

    const selectDonMauValidation = () => {
        if (tableData.length) {
            toast.warn('Đã có máu được chỉ định. Không thể chọn đơn mẫu');
            return false;
        }
        return true;
    };

    return (
        <>
            <div className="d-flex gap-6">
                <div
                    className="d-flex align-items-center gap-3 cursor-pointer"
                    onClick={() => onClose?.()}
                >
                    <IconBack />
                    <span className="fw-500">Quay lại</span>
                </div>
                <ServiceTemplateButton
                    label="Mẫu chỉ định"
                    getSaveParams={getDonMauParams}
                    onSelectMau={onSelectMauChiDinhMau}
                    orderType={parseInt(ORDER_TYPE_ID.MAU)}
                    onSaveValidationFn={saveDonMauValidation}
                    onSelectValidationFn={selectDonMauValidation}
                />
            </div>
            {benhNhanDieuTri ? (
                <InfoPatientRight benhNhanInfo={handleConvertBenhNhanInfo(benhNhanDieuTri)} />
            ) : (
                <div className="spaces h-65"></div>
            )}
        </>
    )
}

export default HeaderMau